import { fundingHqFetch } from './fundingApi';

function agencyQuery(agencyId) {
  const params = new URLSearchParams({ agency_id: agencyId });
  return params.toString();
}

export async function fetchAIAdvisorContext({ agencyId, clientId } = {}) {
  const params = new URLSearchParams({ agency_id: agencyId });
  if (clientId) params.set('client_id', clientId);
  return fundingHqFetch(`/ai-advisor/context?${params.toString()}`);
}

export async function createAIAdvisorSession({ agencyId, clientId, title }) {
  return fundingHqFetch('/ai-advisor/sessions', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      agency_id: agencyId,
      client_id: clientId || null,
      title: title || undefined,
    }),
  });
}

export async function fetchAIAdvisorSessions({ agencyId, clientId } = {}) {
  const params = new URLSearchParams({ agency_id: agencyId });
  if (clientId) params.set('client_id', clientId);
  const data = await fundingHqFetch(`/ai-advisor/sessions?${params.toString()}`);
  return {
    sessions: data.sessions ?? [],
    total: data.total ?? (data.sessions?.length ?? 0),
  };
}

export async function fetchAIAdvisorSession(sessionId, agencyId) {
  return fundingHqFetch(`/ai-advisor/sessions/${encodeURIComponent(sessionId)}?${agencyQuery(agencyId)}`);
}

export async function postAIAdvisorMessage(sessionId, { agencyId, content }) {
  return fundingHqFetch(`/ai-advisor/sessions/${encodeURIComponent(sessionId)}/messages`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ agency_id: agencyId, content }),
  });
}

export async function fetchAIRecommendations({ agencyId, clientId, status } = {}) {
  const params = new URLSearchParams({ agency_id: agencyId });
  if (clientId) params.set('client_id', clientId);
  if (status) params.set('status', status);
  const data = await fundingHqFetch(`/ai-advisor/recommendations?${params.toString()}`);
  return {
    recommendations: data.recommendations ?? [],
    total: data.total ?? (data.recommendations?.length ?? 0),
  };
}

export async function generateClientAIRecommendations(clientId, agencyId) {
  const data = await fundingHqFetch(
    `/clients/${encodeURIComponent(clientId)}/ai-advisor/recommendations/generate?${agencyQuery(agencyId)}`,
    { method: 'POST' },
  );
  return {
    recommendations: data.recommendations ?? [],
    total: data.total ?? (data.recommendations?.length ?? 0),
  };
}

export async function generatePortfolioAIRecommendations(agencyId) {
  const data = await fundingHqFetch(
    `/ai-advisor/recommendations/generate?${agencyQuery(agencyId)}`,
    { method: 'POST' },
  );
  return {
    recommendations: data.recommendations ?? [],
    total: data.total ?? (data.recommendations?.length ?? 0),
  };
}

export async function updateAIRecommendation(recommendationId, agencyId, payload) {
  return fundingHqFetch(
    `/ai-advisor/recommendations/${encodeURIComponent(recommendationId)}?${agencyQuery(agencyId)}`,
    {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    },
  );
}

export async function deleteAIRecommendation(recommendationId, agencyId) {
  return fundingHqFetch(
    `/ai-advisor/recommendations/${encodeURIComponent(recommendationId)}?${agencyQuery(agencyId)}`,
    { method: 'DELETE' },
  );
}
